module.exports = __webpack_public_path__ + "static/media/help-loved-ones.64d148d2.png";